import ViewBase from "../../../framework/core/mvvm/view_base";
import ClubHallInfo from "../component/club_hall_info";
import ClubItemBase from "../component/club_item_base";


const {ccclass, property} = cc._decorator;

@ccclass
export default class ClubRuleBase extends ViewBase {

    @property(ClubHallInfo)
    avatarItem : ClubHallInfo = null;

    @property(cc.Node)
    itemPrefab : cc.Node = null;

    @property([cc.Node])
    pageList : cc.Node[] = [];

    protected itemList : cc.Node[] = [];

    /**
     * 更新主角信息
     */
    protected updateAvatar(){

        //this.avatarInfo.avatarName;
    }

    /**
     * 构建item
     * @param dataList 
     */
    public createItems(dataList : any[]){

        //6个一组
        let PAGE_NUMS = 6;
        
        dataList.forEach((data,index)=>{

            let node = this.itemList[index];      
            if (!node) {            
                node = cc.instantiate(this.itemPrefab);
            }
            
            node.active = true;

            let itemBase = node.getComponent(ClubItemBase);
            itemBase.itemIndex = index;

            if (index < PAGE_NUMS) {
                this.pageList[0].active = true;
                node.parent = this.pageList[0];
            }
            else if(index < PAGE_NUMS * 2){
                this.pageList[1].active = true;
                node.parent = this.pageList[1];

            }else if(index < PAGE_NUMS * 3){
                this.pageList[2].active = true;
                node.parent = this.pageList[2];

            }

            this.itemList[index] = node;
        });

    }

    onDisable(){

        this.pageList.forEach(page=>{
            page.active = false;
        })
    }
    
}
